import {siteConfig, copy} from '../site.js';
/** Serial cart requests. Render only confirmed server state; never retry an uncertain mutation. */
export function createCartController(view, fetcher = window.fetch.bind(window)) {
    const endpoint = '/assets/components/novastars/cart.php';
    let queue = Promise.resolve();
    let pending = 0;
    let token;
    let confirmed;
    let needsRefresh = true;

    async function request(action, data) {
        const response = await fetcher(endpoint, action === 'load' ? {
            credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json', 'X-Novastars-Context': siteConfig().context || 'web'}
        } : {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-Novastars-Context': siteConfig().context || 'web', 'X-Checkout-Token': token},
            body: JSON.stringify({action, data})
        });
        let result;
        try { result = await response.json(); }
        catch (_) { throw new Error(copy('Your cart could not be updated. Please try again.')); }
        if (!response.ok || !result.success) throw new Error(result.errors?.map(error => error.message).join(' ') || 'Your cart could not be updated. Please try again.');
        token = result.token;
        return result;
    }

    function accept(result) {
        confirmed = result;
        needsRefresh = false;
        view.render(result);
        view.busy(pending > 0);
    }

    function run(action, data = {}) {
        pending++;
        view.busy(true);
        const task = queue.then(async () => {
            view.message('');
            try {
                if (action !== 'load' && needsRefresh) accept(await request('load'));
                accept(await request(action, data));
                return true;
            } catch (error) {
                needsRefresh = true;
                if (action !== 'load') {
                    try { accept(await request('load')); } catch (_) { /* Keep original error and confirmed view. */ }
                }
                if (needsRefresh && confirmed) view.render(confirmed);
                view.message(copy(error.message));
                return false;
            } finally {
                pending--;
                view.busy(pending > 0);
            }
        });
        queue = task.catch(() => {});
        return task;
    }

    return {load: () => run('load'), mutate: (action, data) => run(action, data)};
}
